import { animate, timeline } from 'motion';

import CardPatternAnimator from '../components/CardV2PatternAnimator';
import { Component } from '@verndale/core';
import Splitting from 'splitting';
import debounce from 'lodash/debounce';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      svgPattern: this.el.querySelector('.card-pattern'),
      overlay: this.el.querySelector('.insight-cards-item-v2__overlay'),
      image: this.el.querySelector('img')
    };

    if (this.dom.svgPattern)
      this.animator = new CardPatternAnimator(this.dom.svgPattern);
    this.saveInitialMarkup();
    this.initSplitting();
    this.handleResize();

    this.reversed = this.el.dataset.reversed === 'true';
    this.dom.svgPattern.style.opacity = 0;
  }

  addListeners() {
    this.addCardListeners();
    window.addEventListener(
      'resize',
      debounce(this.handleResize.bind(this), 300)
    );
  }

  addCardListeners() {
    this.el.addEventListener('mouseenter', this.handleCardHoverIn.bind(this));
    this.el.addEventListener('mouseleave', this.handleCardHoverOut.bind(this));
  }

  handleCardHoverIn(e) {
    if (!this.isMobile) {
      const playDuration = 1;
      const delayMultiplier = 0.1;
      const card = e.currentTarget;
      const sequence = [];

      sequence.push([
        this.dom.svgPattern,
        {
          opacity: [0, 1]
        },
        { at: 0 },
        { duration: 1 }
      ]);

      sequence.push([
        this.dom.overlay,
        {
          transform: ['skew(-45deg) scale(0, 1)', 'skew(-45deg) scale(2, 1)']
        },
        { duration: 0.5, at: 0 }
      ]);

      card.lineSplit[0].lines.forEach((line, index) => {
        sequence.push([
          line,
          {
            transform: ['translate(0, 0)', 'translate(100px, 0)']
          },
          { duration: 0.2, at: index * delayMultiplier }
        ]);
      });

      const linesReversed = this.reversed
        ? card.lineSplit[0].lines.slice()
        : card.lineSplit[0].lines;

      linesReversed.forEach((line, index) => {
        sequence.push([
          line,
          {
            color: '#fff',
            transform: ['translate(-100px, 0)', 'translate(0, 0)']
          },
          {
            duration: 0.25,
            at: index * delayMultiplier + 0.21,
            color: {
              duration: 0.1,
              at: index * delayMultiplier + 0.21
            }
          }
        ]);
      });

      timeline(sequence, { duration: playDuration });

      if (this.animator) this.animator.inAnimation();

      animate(this.dom.image, { transform: 'scale(1.25)' });
    }
  }

  handleCardHoverOut(e) {
    if (!this.isMobile) {
      const card = e.currentTarget;
      const linesReversed = this.reversed
        ? card.lineSplit[0].lines.slice()
        : card.lineSplit[0].lines;
      linesReversed.forEach((line, index) => {
        const sequence = [
          [
            line,
            {
              opacity: [1, 0],
              transform: ['translate(0, 0)', 'translate(-100px, 0)']
            },
            { duration: 0.15, at: 0.05 * index }
          ],
          [
            line,
            { color: '#1c1c1c' },
            {
              duration: 0,
              at: 0.17 + 0.05 * index
            }
          ],
          [
            line,
            {
              opacity: [0, 1],
              transform: ['translate(100px, 0)', 'translate(0, 0)']
            },
            { duration: 0.15, at: 0.17 + 0.075 * index }
          ]
        ];
        timeline(sequence);
      });
      if (this.animator) this.animator.outAnimation();
      animate(
        this.dom.overlay,
        { transform: 'skew(-45deg) scale(0, 1)' },
        { duration: 0.5 }
      );
      animate(this.dom.svgPattern, { opacity: 0, delay: 0.05 });
      animate(this.dom.image, { transform: 'scale(1)' }, { duration: 1 });
    }
  }

  handleResize() {
    this.isMobile = window.matchMedia('(max-width: 1025px)').matches;
    if (!this.isMobile) {
      this.initSplitting();
      this.addCardListeners();
    }
  }

  saveInitialMarkup() {
    this.el.initialMarkup = this.el.outerHTML;
  }

  initSplitting() {
    this.saveInitialMarkup();
    this.el.lineSplit = Splitting({
      target: this.el,
      by: 'lines'
    });
  }
}

export default Module;
